import React, { Component } from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { Link } from 'gatsby'

import EventCardContent from './EventCardContent'

const EventCardStyle = styled.div`
  overflow: hidden;
  position: relative;
  box-shadow: 0px 5px 20px 5px rgba(160,160,160,0.6);
`;

export default class EventCard extends Component {
  render() {
    const { place } = this.props;
    return (
      <Link to={place.fields.slug}>
        <EventCardStyle>
          <EventCardContent eventInfo={place} />
          <EventCardImg eventFrontImg={place.frontmatter.featuredImage.childImageSharp.fluid} />
        </EventCardStyle>
      </Link>
    )
  }
}

const EventCardImgStyle = styled.div`
  line-height: 0;

  .eventCardImgShadow {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;

    background: rgba(10,10,10,0.31);
    background: -moz-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(10,10,10,0.31)), color-stop(100%, rgba(10,10,10,0)));
    background: -webkit-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: -o-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: -ms-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: linear-gradient(135deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0a0a0a', endColorstr='#0a0a0a', GradientType=1 );
  }
`;

class EventCardImg extends Component {
  render() {
    return (
      <EventCardImgStyle>
        <div className="eventCardImgShadow"></div>
        <Img sizes={this.props.eventFrontImg} />
      </EventCardImgStyle>
    )
  }
}